/**
 * Advanced tab for the Settings page.
 *
 * Displays client-side preferences such as the visual theme.
 * These settings are stored in localStorage and take effect
 * immediately without a server round-trip.
 *
 * @module components/AdvancedTab
 */

import React        from 'react';
import { useI18n }  from '../dataProviders/I18nProvider';
import { useTheme } from '../dataProviders/ThemeProvider';
import * as constants from '../constants';

/**
 * Renders the Advanced settings tab.
 *
 * @returns {React.ReactElement}
 */
export default function AdvancedTab() {
  const { t }              = useI18n();
  const { theme, setTheme } = useTheme();

  /**
   * Handle theme selection change.
   *
   * @param {React.ChangeEvent<HTMLSelectElement>} e
   */
  function handleThemeChange(e) {
    setTheme(e.target.value);
  }

  return (
    <div className="settings-general">
      <div className="settings-panel settings-panel--form">
        <div className="settings-form">

          {/* Theme */}
          <div className="settings-field">
            <div className="settings-label-row">
              <label className="settings-label">{t('settings.theme.label')}</label>
              <span className="settings-help-icon" data-tooltip={t('settings.advanced.theme.help')}>?</span>
            </div>
            <select
              className="settings-select"
              value={theme}
              onChange={handleThemeChange}
            >
              {constants.THEMES.map((th) => (
                <option key={th} value={th}>{t(`theme.${th}`)}</option>
              ))}
            </select>
          </div>

        </div>
      </div>
    </div>
  );
}
